export default "__VITE_ASSET__1a387426__"